import type { ProcessCatalogItem } from "common";
import type { JSX } from "react";
import { Tooltip } from "react-tooltip";

interface ProcessRunActionProps {
  item: ProcessCatalogItem;
  isGuest: boolean;
  onRun: (item: ProcessCatalogItem) => void;
}

export const RUN_DISABLED_TOOLTIP = "Duplicate this process to run it.";

export default function ProcessRunAction({
  item,
  isGuest,
  onRun,
}: ProcessRunActionProps): JSX.Element | null {
  if (isGuest) return null;
  const tooltipId = `process-run-${item.id}`;
  return (
    <>
      {/* A disabled button swallows hover events, so the span carries the tooltip. */}
      <span data-tooltip-id={item.canRun ? undefined : tooltipId}>
        <button
          type="button"
          disabled={!item.canRun}
          onClick={event => {
            event.stopPropagation();
            onRun(item);
          }}
          className="rounded-md bg-indigo-600 px-2.5 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-indigo-600">
          Run
        </button>
      </span>
      {!item.canRun && (
        <Tooltip id={tooltipId} place="top" content={RUN_DISABLED_TOOLTIP} />
      )}
    </>
  );
}
